module.exports = __webpack_public_path__ + "media/svg/bj-6056a538.svg";